import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../assets/images/logo.png";
import { faFacebook, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {

  return (
    <div className="footer">
        <div className="container-fluid desktop">
            <div className="footer-main-grid">
                <div className="footer-column company-column">
                    <img src={logo} alt="logo" className="footer-logo"/>
                    <div className="company-details">
                        <p className="company-name">Bagi Trans d.o.o.</p>
                        <p className="company-hours">Pon - Ned: 08h - 20h</p>
                        <p className="company-email"><a href="mailto:info@bagi.rs">info@bagi.rs</a></p>
                        <p className="company-phone"><a href="tel:+381 69 800 31 28">+381 69 800 31 28</a></p>
                        <p className="company-phone"><a href="tel:+381 69 847 64 64">+381 69 847 64 64</a></p>
                        <div className="social-icons">
                            <a className="facebook" href="https://www.facebook.com/bagitrans/?locale=sr_RS" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                            <a className="instagram" href="https://www.instagram.com/bagi.trans/?hl=en" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a className="youtube" href="https://www.youtube.com/@dejanlazarevic6509" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                        </div>
                    </div>
                </div>
                
                <div className="footer-column">
                    <h4 className="column-title">BRZI LINKOVI</h4>
                    <ul className="footer-links">
                        <li><a href="/">Početna</a></li>
                        <li><a href="/bagis">BAGIS</a></li>
                        <li><a href="/o-nama">O nama</a></li>
                        <li><a href="/sport">Sport</a></li>
                        <li><a href="/blog">Novosti i blog</a></li>
                        <li><a href="/dokumenta">Dokumenta</a></li>
                    </ul>
                </div>
                
                <div className="footer-column">
                    <h4 className="column-title">USLUGE</h4>
                    <ul className="footer-links">
                        <li><a href="/bagis">Prodaja vozila</a></li>
                        <li><a href="/bagis">Otkup vozila</a></li>
                        <li><a href="/sport">Sportska vozila</a></li>
                        <li><a href="/kontakt">Rezerviši vozilo</a></li>
                        <li><a href="/kontakt">Konsultacije</a></li>
                        <li><a href="/kontakt">Tehnička podrška</a></li>
                    </ul>
                </div>
                
                <div className="footer-column newsletter-column">
                    <h4 className="column-title">PRETPLATITE SE</h4>
                    <p className="newsletter-text">Prijavite se za novosti i specijalne ponude! Unesite email i prvi saznajte za popuste i nova vozila.</p>
                    <div className="newsletter-form">
                        <input type="email" placeholder="Unesite email adresu" className="newsletter-input"/>
                        <button type="submit" className="newsletter-button">
                            <FontAwesomeIcon icon={faNewspaper} />
                        </button>
                    </div>
                    <div className="company-address">
                        <a href="https://goo.gl/maps/vQncqWRN5vvGe7MN7" target="_blank" rel="noreferrer">
                            <p><strong>Nikole Tesle 165A</strong></p>
                            <p>36000 Kraljevo, Srbija</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="container-fluid mobile mobile-footer">
            <div className="mobile-logo-section">
                <img src={logo} alt="logo" className="mobile-footer-logo"/>
            </div>
            <div className="mobile-navs">
                <div className="footer-nav">
                    <h5>Početna</h5>
                    <div className="line"></div>
                </div>
                <div className="footer-nav">
                    <h5>BAGIS</h5>
                    <div className="line"></div>
                </div>
                <div className="footer-nav">
                    <h5>O nama</h5>
                    <div className="line"></div>
                </div>
                <div className="footer-nav">
                    <h5>Sport</h5>
                    <div className="line"></div>
                </div>
                <div className="footer-nav">
                    <h5>Blog</h5>
                    <div className="line"></div>
                </div>
                <div className="footer-nav">
                    <h5>Dokumenta</h5>
                    <div className="line"></div>
                </div>
                <div className="footer-nav">
                    <h5>Kontakt</h5>
                    <div className="line"></div>
                </div>
            </div>
            <div className="mobile-info">
                <div className="mobile-contact">
                    <a href="https://goo.gl/maps/vQncqWRN5vvGe7MN7" target="_blank" rel="noreferrer">
                        <p><b>Bagi Trans d.o.o.</b></p>
                        <p><b>Nikole Tesle 165A</b></p>
                        <p>36000 Kraljevo</p>
                        <p>Srbija</p>
                    </a>
                    <div className="mobile-contact-details">
                        <p><a href="tel:+381 69 800 31 28">+381 69 800 31 28</a></p>
                        <p><a href="tel:+381 69 847 64 64">+381 69 847 64 64</a></p>
                        <p><a href="mailto:info@bagi.rs">info@bagi.rs</a></p>
                    </div>
                </div>
                <div className="mobile-social">
                    <a className="facebook" href="https://www.facebook.com/bagitrans/?locale=sr_RS" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                    <a className="instagram" href="https://www.instagram.com/bagi.trans/?hl=en https://www.facebook.com/bagitrans/?locale=sr_RS " target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                    <a className="youtube" href="https://www.youtube.com/@dejanlazarevic6509" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 text-center">
                        <p className="copyright-text">
                            © {new Date().getFullYear()} Bagi Trans d.o.o. Sva prava zadržana.
                        </p>
                        <p className="developer-credit">
                            Developed by <a href="https://omniit.us" target="_blank" rel="noopener noreferrer" className="omnit-link">OmniIT</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Footer;

